import React from 'react';
import './style/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>Privacy e Cookie Policy</h1>

      <section>
        <h2>Titolare del trattamento</h2>
        <p>
          Studio Vinzaglio 24 <br />
          Corso Vinzaglio, 24, 10121 Torino TO, Italia <br />
        </p>
      </section>

      <section>
        <h2>Tipologie di dati raccolti</h2>
        <p>
          Questo sito raccoglie esclusivamente dati tecnici di navigazione,
          tramite cookie strettamente necessari al funzionamento e alla
          sicurezza del sito. Non vengono raccolti, salvati o trattati dati
          personali degli utenti a fini di marketing o profilazione.
        </p>
      </section>

      <section>
        <h2>Finalità del trattamento</h2>
        <p>
          I dati raccolti sono utilizzati unicamente per:
          <ul>
            <li>Consentire il corretto funzionamento tecnico del sito web.</li>
            <li>
              Garantire la sicurezza e protezione contro attività dannose.
            </li>
          </ul>
        </p>
      </section>

      <section>
        <h2>Base giuridica del trattamento</h2>
        <p>
          Il trattamento è basato sul legittimo interesse del titolare a
          garantire il corretto funzionamento del sito (art. 6, par. 1, lett. f)
          GDPR).
        </p>
      </section>

      <section>
        <h2>Cookie</h2>
        <p>
          Questo sito utilizza <strong>solo cookie tecnici essenziali</strong>{' '}
          che non richiedono consenso preventivo ai sensi della normativa
          vigente. Non vengono utilizzati cookie di profilazione o di terze
          parti a fini pubblicitari.
        </p>
      </section>

      <section>
        <h2>Modifiche a questa informativa</h2>
        <p>
          Il Titolare si riserva il diritto di apportare modifiche alla presente
          Privacy Policy. Eventuali modifiche saranno comunicate su questa
          pagina.
        </p>
      </section>

      <p className="last-update">Ultimo aggiornamento: 12/2025</p>
    </div>
  );
};

export default PrivacyPolicy;
